import { render, staticRenderFns } from "./BridgeProceedButton.vue?vue&type=template&id=6254a191&scoped=true"
import script from "./BridgeProceedButton.vue?vue&type=script&lang=ts"
export * from "./BridgeProceedButton.vue?vue&type=script&lang=ts"
import style0 from "./BridgeProceedButton.vue?vue&type=style&index=0&id=6254a191&prod&lang=scss&scoped=true"
import style1 from "./BridgeProceedButton.vue?vue&type=style&index=1&id=6254a191&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6254a191",
  null
  
)

export default component.exports